import { BaseComponent, EventBus, define, prefersReducedMotion } from 'core';
import { SLAB_BATCHES_SELECTED } from 'events';
import 'component-lightbox';
import 'component-skeleton';

export class SlabBatches extends BaseComponent {
  connectedCallback() {
    super.connectedCallback();
    this._inputs = Array.from(this.querySelectorAll('[data-slab-select]'));
    // Tek CTA: başlığın karşısındaki buton. (Listenin altındaki yapışkan kopya
    // kaldırıldı — buton bir orada bir burada belirip kayboluyordu.)
    this._counts = Array.from(this.querySelectorAll('[data-slab-count]'));
    this._buttons = Array.from(this.querySelectorAll('[data-slab-request]'));
    this._lightbox = document.getElementById(this.dataset.lightbox);

    this.querySelectorAll('[data-lightbox-index]').forEach((link) => {
      this.on(link, 'click', (event) => {
        if (!this._lightbox || typeof this._lightbox.openAt !== 'function') return;
        event.preventDefault();
        this._lightbox.openAt(Number(link.dataset.lightboxIndex || 0));
      });
    });

    if (this._buttons.length === 0) return;
    this._inputs.forEach((input) => this.on(input, 'change', () => this._update()));
    this._buttons.forEach((button) => this.on(button, 'click', () => this._request()));

    this._update();
  }

  get selected() {
    return this._inputs
      .filter((input) => input.checked)
      .map((input) => ({
        batch: input.dataset.batch,
        location: input.dataset.location,
        sqft: Number(input.dataset.sqft) || 0,
        sqft_per_slab: Number(input.dataset.sqftPerSlab) || 0,
        pieces: Number(input.dataset.pieces) || 0,
        status: input.dataset.status,
        image: input.dataset.image || '',
      }));
  }

  _update() {
    const n = this._inputs.filter((input) => input.checked).length;
    this._buttons.forEach((button) => {
      button.disabled = n === 0;
    });
    this._counts.forEach((el) => {
      const hint = el.dataset.hint || '';
      el.textContent = n === 0 ? hint : el.dataset.template.replace('__n__', n);
    });
  }

  _request() {
    const batches = this.selected;
    if (batches.length === 0) return;
    const detail = { batches };
    this.dispatchEvent(new CustomEvent(SLAB_BATCHES_SELECTED, { bubbles: true, detail }));
    EventBus.emit(SLAB_BATCHES_SELECTED, detail);

    const form = document.querySelector('[data-slab-quote-form]');
    if (!form) return;
    form.scrollIntoView({ block: 'start', behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    const field = form.querySelector('input:not([type="hidden"]), textarea, select');
    if (field) field.focus({ preventScroll: true });
  }
}

define('slab-batches', SlabBatches);
